import React from 'react';
import '../../css/components/Modals/FooterModal.css';

const FooterModal = ({ isOpen, title, content, closeModal }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <span onClick={closeModal} className="close-button">&times;</span>
                </div>
                <div dangerouslySetInnerHTML={{ __html: content }} />
                <br />
            </div>
        </div>
    );
};

export default FooterModal;